import { useEffect, useState } from "react";

// Renders below-the-fold content once the browser is idle after first paint, so the
// hero paints sooner. Renders at once in tests and when a #link needs its target.
const DeferredRender = ({ children }) => {
  const [ready, setReady] = useState(
    () =>
      process.env.NODE_ENV === "test" ||
      typeof window === "undefined" ||
      Boolean(window.location.hash)
  );

  useEffect(() => {
    if (ready) return undefined;
    if ("requestIdleCallback" in window) {
      const id = window.requestIdleCallback(() => setReady(true), { timeout: 1200 });
      return () => window.cancelIdleCallback(id);
    }
    const timer = setTimeout(() => setReady(true), 200);
    return () => clearTimeout(timer);
  }, [ready]);

  return ready ? children : null;
};

export default DeferredRender;
